export default "__VITE_ASSET___M6lMNS3__"